// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--5dd10";
export var heading1 = "heading-module--heading1--30070";
export var heading2 = "heading-module--heading2--16827";